import React, {ReactElement} from 'react';
import {createBudget} from 'core/Budget';
import {calcDailyBudget} from 'core/DailyBudget';
import {useFutureDaysCount, useKeyboardInput} from 'ui/utils/core';

import {Section} from 'components/Section';
import {Amount as Total} from '../Amount';
import {DailyAmount as Daily} from '../Daily';
import {BudgetDate as Date} from '../Date';

export const Budget = (): ReactElement => {
  const candidateAmount = useKeyboardInput();
  const candidateDaysCount = useFutureDaysCount();
  const budget = createBudget(candidateAmount, candidateDaysCount);
  const dailyBudget = calcDailyBudget(budget, []);

  return (
    <>
      <Section>
        <Total />
        <Daily amount={dailyBudget.amount} />
      </Section>
      <Date date={budget.finishDate} />
    </>
  );
};
